// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"2064feb7","76":"dda7552b","210":"b0d305dc","243":"03df9823","343":"743b4990","364":"ee959944","433":"e9847676","435":"b1eddaf0","484":"68ee8041","487":"0b816247","529":"159826f0","540":"5f47688b","683":"43680012","755":"b73e1065","869":"c1718043","912":"aaa01a18"}[chunkId] + ".chunk.js";
};